module.exports = __webpack_public_path__ + "static/media/lohono-calligraphy-white.a4fb64aa.svg";